/**
 * 待整理 后续尽量不往这里面添加信息
 */
import { Base64 } from 'js-base64';
import { NativeService } from '@/service/native/nativePluginService';
import ClipboardJS from 'clipboard';
import { isUIWebview } from 'utils/environment';
import { JSEncrypt } from 'jsencrypt';
let util = {};
let clipboardMap = {};
import * as newUtils from 'utils/indexV2';
let CryptoJS;
// 优化 延迟加载
function getCryptoJSEnCodeInfo() {
  if (!CryptoJS) {
    CryptoJS = require('crypto-js');
  }
  const CryptoJSKey = CryptoJS.enc.Utf8.parse('uBdUx82vPHkDKb284d7NkjFoNcKWBuka');
  const CryptoJSkeyIv = CryptoJS.enc.Utf8.parse('Ai2ecTvyERY6t8w8');
  const CryptoJSEnCodeMode = {
    iv: CryptoJSkeyIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  };
  return {
    CryptoJSKey,
    CryptoJSEnCodeMode,
  };
}
export const clipboardInstance = (util.clipboardInstance = function (className, callback) {
  if (clipboardMap[className]) {
    //return clipboardMap[className]
  } else {
    let clipboardJSInstance = new ClipboardJS(className);
    clipboardMap[className] = clipboardJSInstance;
    clipboardJSInstance.on('success', function (e) {
      //e.clearSelection();
      callback();
    });

    clipboardJSInstance.on('error', function (e) {});
    //return clipboardJSInstance;
  }
});

/**
 * 产生随机 id
 * @param length 长度
 * @return obj 字符串
 */
export function randomString(length) {
  let id = '';
  let chars = 'ABCDEFGHiJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
  for (let i = 0; i < length; i++) {
    id += chars.charAt(Math.floor(Math.random() * 60));
  }
  return id;
}

/**
 *用于生成uuid
 */
export function randomUUIDString() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export const title = (util.title = function (title) {
  title = title || 'iView admin';
  window.document.title = title;
});

export const inOf = (util.inOf = function (arr, targetArr) {
  let res = true;
  arr.map((item) => {
    if (targetArr.indexOf(item) < 0) {
      res = false;
    }
  });
  return res;
});

export const oneOf = (util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
});
// 日期格式化
export const dateFormat = (util.dateFormat = newUtils.dateFormat);
// 获取时间戳
export const getDateStamp = (util.getDateStamp = newUtils.getDateStamp);

// 根据时间字符串获取时间对象
export const getDateInstance = (util.getDateInstance = newUtils.getDateInstance);
// 获取两个时间段间相差的天数，需要注意顺序问题
export const getDiffDay = (util.getDiffDay = function (startDate, endDate) {
  if (!startDate || !endDate) {
    return;
  }
  startDate = util.dateFormat(startDate);
  endDate = util.dateFormat(endDate);
  let startDateObj = getDateInstance(startDate);
  if (!startDateObj) return;
  let endDateObj = getDateInstance(endDate);
  if (!endDate) return;
  let startDateStmap = startDateObj.getTime(),
    endDateStmap = endDateObj.getTime();
  let diffDayStmap = endDateStmap - startDateStmap;
  return diffDayStmap < 0 ? 1 : Math.ceil(diffDayStmap / 1000 / 60 / 60 / 24) + 1;
});

// 比较两个日期大小
export const compareDate = (util.compareDate = function (date1, date2) {
  return util.getDateStamp(date1) >= util.getDateStamp(date2);
});

// 比较两个日期大小
export const compareDateIsSmall = (util.compareDateIsSmall = function (date1, date2) {
  return util.getDateStamp(date1) > util.getDateStamp(date2);
});

// 比较两个时间 格式 12:30 9:20
export const compareTime = (util.compareTime = function (time1, time2) {
  let array1 = time1.split(':'),
    array2 = time2.split(':');
  return parseInt(array1[0]) * 60 + parseInt(array1[1]) > parseInt(array2[0]) * 60 + parseInt(array2[1]);
});

// 将时间转换为时间戳
export const revertTimeToTimeStamp = (util.revertTimeToTimeStamp = function (time1) {
  let array = time1.split(':');
  return (parseInt(array[0]) * 60 + parseInt(array[1])) * 60000;
});

// 比较两个日期是否在同一天
export const isTheSameDay = (util.isTheSameDay = function (date1, date2) {
  if (date1 && date2) {
    let compareOne = getDateInstance(date1),
      compareTwo = getDateInstance(date2);
    return compareOne.Format('yyyy-MM-dd') === compareTwo.Format('yyyy-MM-dd');
  } else {
    return false;
  }
});

// 日期浮动
export const ymdFloat = (util.ymdFloat = function (date) {
  return (flag) => {
    let fn = () => {};
    switch (flag) {
      case 'year':
        fn = util.yearFloat;
        break;
      case 'month':
        fn = util.monthFloat;
        break;
      case 'date':
        fn = util.dateFloat;
        break;
    }
    return fn();
  };
});

// 在某个年上浮动多少年
export const yearFloat = (util.yearFloat = function (date) {
  let dateObj = util.getDateInstance(date);
  if (!dateObj) {
    return {};
  }
  let currentYear = dateObj.getFullYear();
  let currentMonth = dateObj.getMonth();
  dateObj.setDate(1);
  return {
    _preHandle(years) {
      if (!years) years = 0;
      let integerYears = parseInt(years),
        floatYears = parseFloat(years),
        decimalYears = floatYears - integerYears,
        integerMonth = parseInt(decimalYears * 12);
      return {
        integerYears,
        integerMonth,
      };
    },
    add(years) {
      let { integerYears, integerMonth } = this._preHandle(years);
      dateObj.setFullYear(currentYear + integerYears);
      dateObj.setMonth(currentMonth + integerMonth);
      return dateObj.Format('yyyy-MM-dd');
    },
    minus(years) {
      let { integerYears, integerMonth } = this._preHandle(years);
      dateObj.setFullYear(currentYear - integerYears);
      dateObj.setMonth(currentMonth - integerMonth);
      return dateObj.Format('yyyy-MM-dd');
    },
  };
});
// 在某个月上浮动多少月
export const monthFloat = (util.monthFloat = function (months) {
  // let dateObj = util.getDateInstance(date);
  let dateObj = util.getDateInstance();
  if (!dateObj) {
    return {};
  }
  let currentMonth = dateObj.getMonth();
  dateObj.setDate(1);
  return {
    add: (days) => {
      dateObj.setMonth(currentMonth + months);
      return dateObj.Format('yyyy-MM-dd');
    },
    minus: (days) => {
      dateObj.setMonth(currentMonth - months);
      return dateObj.Format('yyyy-MM-dd');
    },
  };
});
// 在某个日期上浮动天数
export const dateFloat = (util.dateFloat = function (date) {
  let dateObj = util.getDateInstance(date);
  if (!dateObj) {
    return {};
  }
  let currentDate = dateObj.getDate();
  return {
    add: (days) => {
      return util.dateFormat(new Date(dateObj.setDate(currentDate + days)), 'yyyy-MM-dd hh:mm');
    },
    minus: (days) => {
      return util.dateFormat(new Date(dateObj.setDate(currentDate - days)), 'yyyy-MM-dd hh:mm');
    },
    addMinutes: (m) => {
      let currentMin = dateObj.getMinutes();
      return util.dateFormat(new Date(dateObj.setMinutes(currentMin + m)), 'yyyy-MM-dd hh:mm');
    },
  };
});
// 金额格式化
export const moneyFormat = (util.moneyFormat = function (value, precision = 2) {
  if (!value) return (0).toFixed(precision);
  if (isNaN(value)) {
    return value;
  }
  return (+value).toFixed(precision).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
});
// 把下划线和中划线写法改为驼峰写法
export const changeUnderLineToUppercase = (util.changeUnderLineToUppercase = function (str) {
  return str.replace(/[_-](\w){1}/gim, function () {
    return arguments[1].toUpperCase();
  });
});

// get请求时转换参数
export const revertGetParams = (util.revertGetParams = newUtils.revertGetParams);

// 判断一个对象是否为空对象
export const isEmptyObj = (util.isEmptyObj = function (obj) {
  if (!obj) return true;
  if (util.getType(obj) !== 'object') {
    return false;
  }
  for (let key in obj) {
    return false;
  }
  return true;
});
// 获取某个符合条件的数据
export const filterOneItem = (util.filterOneItem = function (ary, fn) {
  if (!ary || !ary.length) return ary;
  for (let i = 0, len = ary.length; i < len; i++) {
    let item = ary[i];
    if (fn(item)) {
      return item;
      break;
    }
  }
});

// 判断一个对象是有多个key
export const isObjectOverOneKey = (util.isObjectOverOneKey = function (obj) {
  if (!obj) return false;
  let keys = Object.keys(obj);
  return keys.length > 1;
});
// 转换一个时间对象为toISOString
export const toISOString = (util.toISOString = function (date) {
  if (!date) return date;
  if (window.moment) {
    //直接使用toISOString返回的字符串会带毫秒 老中控app都不带毫秒 可能会有未知错误
    return window.moment(date).utc().format();
  } else {
    let d = getDateInstance(date);
    if (d && d.toString() === 'Invalid Date') {
      d = new Date(date.replace(/\-/gm, '/'));
    }
    if (d && d.toISOString) {
      return d.toISOString();
    }
    return date;
  }
});

/**
 * 获取数据类型 兼容revertGetParams
 * @param obj
 * @returns {*}
 */
export const getType = (util.getType = newUtils.getType);

/**
 * 深拷贝方法，支持多个数据拷贝，多个数据拷贝时第一项必须为数组或对象类型
 * 第一项为对象则其余项也必须是对象，返回值为多个对象的结合
 * 第一项为数组，则将多个数组合并，不是数组的像直接加入数组中
 * @param source
 * @returns {*}
 */
export const deepClone = (util.deepClone = newUtils.deepClone);

/**
 * 按值比较两个数据
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
export const compareValue = (util.compareValue = (obj1, obj2) => {
  let type = util.getType(obj1);
  if (type !== util.getType(obj2)) {
    return false;
  }
  if (type === 'array') {
    let length1 = obj1.length;
    if (length1 !== obj2.length) {
      return false;
    }
    for (let i = 0; i < obj1; i++) {
      if (!util.compareValue(obj1[i], obj2[i])) {
        return false;
      }
    }
    return true;
  } else if (type === 'object') {
    let keys = Object.keys(obj1);
    let length = keys.length;
    if (length !== Object.keys(obj2).length) {
      return false;
    }
    keys.forEach((key) => {
      if (!util.compareValue(obj1[key], obj2[key])) {
        return false;
      }
    });
    return true;
  } else if (type === 'date' || type === 'regExp') {
    return obj1.toString() === obj2.toString();
  } else if (isNaN(obj1)) {
    return isNaN(obj2);
  } else {
    return obj1 === obj2;
  }
});

export const fromJson = (util.fromJson = (json) => {
  try {
    return typeof json === 'string' ? JSON.parse(json) : json;
  } catch (e) {
    return undefined;
  }
});

util.toJson = (obj) => {
  return util.getType(obj) === 'object' ? JSON.stringify(obj) : obj;
};

export const rateDiff = (util.rateDiff = (actualCurrencyRate, companyCurrencyRate) => {
  return (
    Math.round(((actualCurrencyRate * 10000 - companyCurrencyRate * 10000) / (companyCurrencyRate * 10000)) * 10000) /
    100
  );
});

/**
 * 获取state
 * @param storePath
 * @param stateName
 * @param vue
 * @param mapState
 * @returns {*}
 */
export const getStateFromStore = (util.getStateFromStore = (storePath, stateName, vue, mapState) => {
  return mapState(storePath, {
    [stateName]: (state) => state[stateName],
  })[stateName].call(vue);
});

/**
 * 调用mutation更新store
 * @param storePath
 * @param mutationName
 * @param vue
 * @param payload
 * @param mapMutations
 */
export const commitMutationToStore = (util.commitMutationToStore = (
  storePath,
  mutationName,
  vue,
  payload,
  mapMutations
) => {
  mapMutations(storePath, [mutationName])[mutationName].call(vue, payload);
});

/**
 *  通过时间 hh:mm:ss 获取 hh:mm
 *  @param time hh:mm:ss
 *  @return time hh:mm
 */
export const getHourAndMinuteFromTime = (util.getHourAndMinuteFromTime = (time) => {
  if (!time) return '';
  return time.split(':').slice(0, 2).join(':');
});
/**
 * 根据时期获取 yyyy-MM-dd 获取 mm年dd月,目前只支持中文
 * @param date yyyy-MM-dd
 * @param date MM年dd月
 */
export const getCHMonthAndDayFromDate = (util.getCHMonthAndDayFromDate = (date, showYear = false) => {
  if (!date) return date;
  if (!date) return date;
  let d = new Date(date);
  if (isNaN(d.getTime())) {
    return date;
  }
  let MM = d.getMonth(),
    dd = d.getDate(),
    yyyy = d.getFullYear();
  let tempObj = [
    window.$t('other-1.key38', { cm: '1月' }),
    window.$t('other-1.key39', { cm: '2月' }),
    window.$t('other-1.key40', { cm: '3月' }),
    window.$t('other-1.key41', { cm: '4月' }),
    window.$t('other-1.key42', { cm: '5月' }),
    window.$t('other-1.key43', { cm: '6月' }),
    window.$t('other-1.key44', { cm: '7月' }),
    window.$t('other-1.key45', { cm: '8月' }),
    window.$t('other-1.key46', { cm: '9月' }),
    window.$t('other-1.key47', { cm: '10月' }),
    window.$t('other-1.key48', { cm: '11月' }),
    window.$t('other-1.key49', { cm: '12月' }),
  ];
  if (['ch', 'zh', 'zh_cn', 'ja'].includes(window.getSelectedLanguage())) {
    return showYear ? `${yyyy}年${MM + 1}月${dd}日` : `${MM + 1}月${dd}日`;
  } else {
    return showYear ? `${dd} ${tempObj[MM]},${yyyy}` : `${dd} ${tempObj[MM]}`;
  }
});
/**
 * 根据日期获取周几
 * @param date
 * @return week
 */
export const getWeekFromDate = (util.getWeekFromDate = (date) => {
  if (!date) return date;
  let d = new Date(date);
  if (!d.getDay) return date;
  let weekAry = [
    window.$t('other-1.key28', { cm: '周日' }),
    window.$t('other-1.key29', { cm: '周一' }),
    window.$t('other-1.key30', { cm: '周二' }),
    window.$t('other-1.key31', { cm: '周三' }),
    window.$t('other-1.key32', { cm: '周四' }),
    window.$t('other-1.key33', { cm: '周五' }),
    window.$t('other-1.key34', { cm: '周六' }),
  ];
  return weekAry[d.getDay()];
});
/**
 * 判断给定时期是否是今天
 * @param {*} date
 * @return Boolean
 */
export const isDateEquealsToday = (util.isDateEquealsToday = (date) => {
  if (!date) return false;
  let formatString = 'yyyy-MM-dd';
  let today = new Date().Format(formatString);
  date = new Date().Format(formatString);
  return date == today;
});
/**
 * 打开一个页面，可以通过它统一调用不同平台的API
 * @param {*} url
 */
export const openUrl = (util.openUrl = (url, useNativeTitle) => {
  url = url.replace('CallBack', 'callback');
  url = url.replace(/\&callback=.+\/closeInAppBrowser.html/, '');
  // return location.href = url;
  return new Promise((resolve, reject) => {
    NativeService().openWin(
      { url, useNativeTitle },
      (success) => {
        resolve(success);
      },
      (err) => {
        reject(err);
        location.href = url;
      }
    );
  });
});
/**
 * 判断一个小数的位数是否>=给定的位数
 * @param {Number} number 要判断的小数
 * @param {Number} len 要判断的位数
 */
export const assetDecimalsLength = (util.assetDecimalsLength = (number, len) => {
  number = number + '';
  let numberAry = number.split('.');
  if (numberAry && numberAry[1]) {
    let decimal = numberAry[1];
    if (decimal.length >= len) {
      return true;
    }
  }
  return false;
});
/**
 * base64编码
 */
export const encodeBase64 = (util.toBase64 = (val) => {
  return Base64.encode(val);
});
/**
 * base64解码
 */
export const decodeBase64 = (util.fromBase64 = (val) => {
  return Base64.decode(val);
});
/**
 * 使某一个文本节点运动一段距离，调用方式为 scrollTo(dom)({diffX: 50, diffY: 50})
 * @param {Element} dom 要运动的文档节点
 */
export const scrollTo = (util.scrollTo = (dom) => {
  if (!dom) return () => {};
  let num = 0,
    time = 5;
  return ({ diffX = 0, diffY = 0 }) => {
    if (!diffX && !diffY) return;
    let initPosX = dom.scrollLeft,
      initPosY = dom.scrollTop,
      posX = 0,
      posY = 0,
      isAddX = diffX > 0 ? true : false,
      isAddY = diffY > 0 ? true : false,
      currentX = 0,
      currentY = 0;
    (diffX = Math.abs(diffX)), (diffY = Math.abs(diffY));
    const move = () => {
      let vx = Math.max((diffX - posX) / time, 1),
        vy = Math.max((diffY - posY) / time, 1);
      if (num++ > 1000) return;
      if (posX >= diffX && posY >= diffY) {
        return;
      }
      if (posX < diffX) {
        posX += vx;
      }
      if (posY < diffY) {
        posY += vy;
      }
      currentX = isAddX ? initPosX + posX : initPosX - posX;
      currentY = isAddY ? initPosY + posY : initPosY - posY;
      if (dom.scrollTo) {
        dom.scrollTo(currentX, currentY);
      } else {
        dom.scrollTop = currentY;
        dom.scrollLeft = currentX;
      }
      requestAnimationFrame(move);
    };
    move();
  };
});

/**
 * 校验合法的金额
 * @param num
 */
export const validateMoney = (util.validateMoney = (num) => {
  let reg = /^(\d+(\.\d*)?)$/g;
  return reg.test(num);
});
/**
 * 校验是否为json字符串
 * @param {String} 需要校验的支付串
 */
export const isJsonStr = (util.isJsonStr = (str) => {
  if (!str || typeof str != 'string') return false;
  let reg = /^[\[\{].+[\}\]]$/gim;
  return reg.test(str);
});

let windowHeight = window.innerHeight;
/**
 * 键盘弹出的操作
 */
export const onKeyboardChange = (util.onKeyboardChange = ({ up = () => {}, off = () => {} }) => {
  const onResize = () => {
    let currInnerHeight = window.innerHeight;
    if (windowHeight > currInnerHeight) {
      up && up();
    } else {
      off && off();
    }
    windowHeight = window.innerHeight;
  };

  if (isUIWebview()) return;

  onResizeEventHandle({
    method: onResize,
    key: 'onKeyboardChange',
  });
});

/**
 * 滚动至可视区域辅助方法
 * @param el
 * @param diff
 * @returns {{el: *, scrollType: string}}
 */
const getScrollEl = (el, diff) => {
  let scrollType,
    firstEl = el;
  diff = -diff;

  // 优先寻找可滚动父级
  while (el !== document.body && el) {
    if (el.scrollTop + diff < el.scrollHeight && el.scrollHeight !== el.clientHeight) {
      scrollType = SCROLL;
      break;
    }
    el = el.parentNode;
  }

  if (!scrollType) {
    while (firstEl !== document.body && firstEl) {
      if (firstEl.clientHeight >= window.innerHeight) {
        scrollType = TRANSFORM;
        break;
      }
      firstEl = firstEl.parentNode;
    }
  }

  return {
    el,
    scrollType,
  };
};

let scrollEls = [];
const SCROLL = 'SCROLL';
const TRANSFORM = 'TRANSFORM';

export const nativeScrollIntoView = (util.nativeScrollIntoView = (dom) => {
  if (dom.scrollIntoViewIfNeeded) {
    dom.scrollIntoViewIfNeeded(false);
  } else if (dom.scrollIntoView) {
    dom.scrollIntoView(false);
  }
});

/**
 * 当键盘弹起时滚动dom至可视区域
 */
export const domScrollIntoView = (util.domScrollToView = (dom) => {
  let scrollEl;

  onKeyboardChange({
    up: () => {
      let pos = getElPosition(dom),
        target,
        diff;
      if (pos.y + pos.height > window.innerHeight) {
        target = window.innerHeight - pos.height;
        diff = target - pos.y;
        scrollEl = getScrollEl(dom, diff);
        let { el, scrollType } = scrollEl;
        if (el) {
          if (scrollType === SCROLL) {
            // diff为负数
            // 70用于避免按钮遮挡
            el.scrollTop = el.scrollTop - diff + 70;
          } else {
            el.style.transition = 'transform 0.2s ease-out 0s';
            el.style.webkitTransition = '-webkit-transform 0.2s ease-out 0s';
            el.style.transform = `translateY(${diff - 20}px)`;
            el.style.webkitTransform = `translateY(${diff - 20}px)`;
          }
          scrollEls.push(scrollEl);
        }
      }
    },
    off: () => {
      while (scrollEls.length) {
        let { el, scrollType } = scrollEls.pop();
        if (el) {
          if (scrollType === SCROLL) {
            return;
          } else {
            el.style.transition = '';
            el.style.webkitTransition = '';
            el.style.transform = '';
            el.style.webkitTransform = '';
          }
        }
      }
    },
  });
});

/**
 * 无键盘弹起的直接滚动至可视区域，不修改style
 * @type {util.domScrollIntoViewV2}
 */
export const domScrollIntoViewV2 = (util.domScrollIntoViewV2 = (dom) => {
  let pos = getElPosition(dom),
    target,
    diff;
  if (pos.y + pos.height > window.innerHeight - 70) {
    target = window.innerHeight - pos.height;
    diff = target - pos.y - 70; // 70避免底部按钮遮挡
  } else if (pos.y < 0) {
    diff = -pos.y + 10; // 10保证顶部全部可见
  }

  if (diff) {
    let scrollEl = getScrollEl(dom, diff);
    let { el, scrollType } = scrollEl;
    if (el) {
      if (scrollType === SCROLL) {
        // diff为负数
        el.scrollTop = el.scrollTop - diff;
      }
    }
  }
});

export const addShowKey = (util.addShowKey = (item, showKey, curShowKey) => {
  let result = {
    ...item,
  };
  if (typeof item !== 'object') {
    return item;
  } else if (showKey && typeof showKey === 'function') {
    // 为对象添加展示的随机key值
    result[curShowKey] = showKey(item);
  }
  return result;
});

/**
 * 计算两点间距离
 * @type {function(*, *)}
 */
export const computedDistance = (util.computedDistance = (a, b) => {
  let topKey, leftKey;
  if (a.top !== undefined) {
    topKey = 'top';
    leftKey = 'left';
  } else {
    topKey = 'x';
    leftKey = 'y';
  }
  return Math.sqrt(Math.pow(a[topKey] - b[topKey], 2) + Math.pow(a[leftKey] - b[leftKey], 2));
});

/**
 *  对于对象数组，根据对象中某个key进行数组去重
 *  arr 需要去重的数组
 *  compareKey 需要根据哪个key进行去重
 */
export const uniqueAryByObjKey = (util.uniqueAryByObjKey = (arr, compareKey) => {
  let values = {};
  return arr.filter((item) => {
    let value = item[compareKey];
    if (!values[value]) {
      values[value] = true;
      return true;
    }
    return false;
  });
});
/**
 * 数组去重
 */
export const uniqueAry = (util.uniqueAry = (arr) => {
  if (!arr || !arr.length) return arr;
  let tempAry = [];
  tempAry = arr.reduce((result, item, index) => {
    if (!result.includes(item)) {
      result.push(item);
    }
    return result;
  }, tempAry);
  return tempAry;
});
/**
 * 根据给定的fn返回第一个符合条件的值的索引
 */
export const findInArray = (util.findInArray = (ary, fn) => {
  if (!ary || ary.length === 0) return -1;
  for (let i = 0, len = ary.length; i < len; i++) {
    let item = ary[i];
    if (fn(item, i)) {
      return i;
    }
  }
  return -1;
});

/**
 * 获取元素在页面中位置及宽高
 * @param el
 * @returns {{x: number, y: number, width: number, height: number}}
 */
export const getElPosition = (el) => {
  let pos = { x: 0, y: 0, width: 0, height: 0 };
  pos.width = el.clientWidth;
  pos.height = el.clientHeight;

  let offsetEl = el,
    scrollEl = el;

  while (offsetEl !== document.body && offsetEl) {
    pos.x += offsetEl.offsetLeft;
    pos.y += offsetEl.offsetTop;
    offsetEl = offsetEl.offsetParent;
  }

  while (scrollEl !== document.body && scrollEl) {
    pos.x -= scrollEl.scrollLeft;
    pos.y -= scrollEl.scrollTop;
    scrollEl = scrollEl.parentNode;
  }
  pos.x += document.body.clientLeft - document.body.scrollLeft;
  pos.y += document.body.clientTop - document.body.scrollTop;
  return pos;
};

/**
 * 这个方法用于写window.onresize时避免冲突
 * 但是似乎考虑得不太全面，建议以后不要用了，改成window.addEventListener('resize')
 */
let onResizeEvents = {};
export const onResizeEventHandle = (util.onResizeEventHandle = ({ method, action = 'push', key }) => {
  if (!window.onresize) {
    window.onresize = () => {
      for (let curKey in onResizeEvents) {
        onResizeEvents[curKey] && onResizeEvents[curKey]();
      }
    };
  }

  if (action === 'push') {
    onResizeEvents[key] = method;
  } else if (onResizeEvents[key]) {
    delete onResizeEvents[key];
  }
});

/**
 *
 * @type {util.quickSort}
 */
export const quickSort = (util.quickSort = (arr, fn) => {
  if (arr.length <= 1) {
    return arr;
  }

  var pivotIndex = Math.floor(arr.length / 2);

  var pivot = arr.splice(pivotIndex, 1)[0];

  var left = [];

  var right = [];

  for (var i = 0; i < arr.length; i++) {
    if (fn && fn(arr[i], pivot)) {
      left.push(arr[i]);
    } else {
      right.push(arr[i]);
    }
  }
  return quickSort(left, fn).concat([pivot], quickSort(right, fn));
});

/**
 * 把嵌套的对象改写为单层的对象
 * @param {Object} json 需要处理的json
 */
export const translateDeepObjectToSimple = (util.translateDeepObjectToSimple = (json) => {
  let localMap = {};

  function loop(keys, json) {
    for (let key in json) {
      let value = json[key];
      key = keys ? `${keys}.${key}` : `${key}`;
      if (typeof value === 'object') {
        loop(key, value);
      } else {
        localMap[key] = value;
      }
    }
  }

  loop('', json);
  return localMap;
});

export const debounce = (fn, time) => {};

export const getTextByMaxWidth = (util.getTextByMaxWidth = (text, maxWidth, font, direction = 'ltr') => {
  let canvas = document.createElement('canvas'),
    ctx = canvas.getContext('2d');

  if (!text || !maxWidth || !font) {
    return text;
  }

  ctx.font = font;
  let arr = text.split(''),
    arrLength = arr.length,
    curText = '';
  if (direction === 'ltr') {
    for (let i = 0; i < arrLength; i++) {
      curText += arr[i];
      let metrics = ctx.measureText(curText);
      let testWidth = metrics.width;
      if (testWidth > maxWidth) {
        let n = 1;
        while (true) {
          let tempText = curText.slice(0, curText.length - n) + '...';
          let tempMetrics = ctx.measureText(tempText);
          let tempWidth = tempMetrics.width;
          n++;
          if (tempWidth < maxWidth) {
            curText = tempText;
            break;
          }
        }
        return curText;
      }
    }
  } else {
    for (let i = arrLength - 1; i >= 0; i--) {
      curText = arr[i] + curText;
      let metrics = ctx.measureText(curText);
      let testWidth = metrics.width;
      if (testWidth > maxWidth) {
        let n = 1;
        while (true) {
          let tempText = '...' + curText.slice(n, curText.length);
          let tempMetrics = ctx.measureText(tempText);
          let tempWidth = tempMetrics.width;
          n++;
          if (tempWidth < maxWidth) {
            curText = tempText;
            break;
          }
        }
        return curText;
      }
    }
  }

  return curText;
});

export const blobToFile = function blobToFile(blob, name) {
  return new File(blob, name);
};

export const dataURLtoBlob = function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export function base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data\:([^\;]+)\;base64,/gim, '');
  var binary = atob(base64);
  var len = binary.length;
  var buffer = new ArrayBuffer(len);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return buffer;
}

// ArrayBuffer对象 Unicode码转字符串
export function getStringFromCharCode(dataView, start, length) {
  var str = '';
  var i;
  for (i = start, length += start; i < length; i++) {
    str += String.fromCharCode(dataView.getUint8(i));
  }
  return str;
}

function getOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer);
  var length = dataView.byteLength;
  var orientation;
  var exifIDCode;
  var tiffOffset;
  var firstIFDOffset;
  var littleEndian;
  var endianness;
  var app1Start;
  var ifdStart;
  var offset;
  var i;
  // Only handle JPEG image (start by 0xFFD8)
  if (dataView.getUint8(0) === 0xff && dataView.getUint8(1) === 0xd8) {
    offset = 2;
    while (offset < length) {
      if (dataView.getUint8(offset) === 0xff && dataView.getUint8(offset + 1) === 0xe1) {
        app1Start = offset;
        break;
      }
      offset++;
    }
  }
  if (app1Start) {
    exifIDCode = app1Start + 4;
    tiffOffset = app1Start + 10;
    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
      endianness = dataView.getUint16(tiffOffset);
      littleEndian = endianness === 0x4949;

      if (littleEndian || endianness === 0x4d4d /* bigEndian */) {
        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002a) {
          firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

          if (firstIFDOffset >= 0x00000008) {
            ifdStart = tiffOffset + firstIFDOffset;
          }
        }
      }
    }
  }
  if (ifdStart) {
    length = dataView.getUint16(ifdStart, littleEndian);

    for (i = 0; i < length; i++) {
      offset = ifdStart + i * 12 + 2;
      if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */) {
        // 8 is the offset of the current tag's value
        offset += 8;

        // Get the original orientation value
        orientation = dataView.getUint16(offset, littleEndian);

        // Override the orientation with its default value for Safari (#120)
        if (/(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent)) {
          dataView.setUint16(offset, 1, littleEndian);
        }
        break;
      }
    }
  }
  return orientation;
}

import store from 'src/vuex';

export const fileCompress = (util.fileCompress = function fileCompress(file) {
  let fileName = file.name,
    compressionRatio = 1;
  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas');
    // 获取canvas
    let ctx = canvas.getContext('2d');
    let reader = new FileReader();
    reader.onload = (e) => {
      // target.result 该属性表示目标对象的DataURL
      let data = e.target.result;
      let buffer = base64ToArrayBuffer(data);
      let orientation = getOrientation(buffer);
      const canvasOrientationMap = {
        1: 0,
        3: 180,
        6: 90,
        8: -90,
      };
      orientation = canvasOrientationMap[orientation] || 0;

      let image = new Image();
      image.onload = (e) => {
        let { width, height } = image;
        if (image.width > 600 || image.height > 1000) {
          width = image.width * 0.5;
          height = image.height * 0.5;
        }
        let exchangeWidth = (orientation / 90) % 2 === 0,
          scaledWidth = exchangeWidth ? width : height,
          scaledHeight = exchangeWidth ? height : width,
          centerX = scaledWidth / 2,
          centerY = scaledHeight / 2;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;

        // 旋转
        ctx.translate(centerX, centerY);
        ctx.rotate((orientation * Math.PI) / 180);
        let resetCenterX = -centerX,
          resetCenterY = -centerY;
        if (!exchangeWidth) {
          resetCenterX = -centerY;
          resetCenterY = -centerX;
        }
        ctx.translate(resetCenterX, resetCenterY);

        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
        // 坐标系还原
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        // //
        // let dpi = 2;
        // if (window.devicePixelRatio) {
        //   dpi = window.devicePixelRatio;
        // }
        // compressionRatio = compressionRatio / dpi;
        compressionRatio = store.getters.getIsIOS ? 0.4 : 0.5;
        let base64Data = canvas.toDataURL('image/jpeg', compressionRatio);
        let blobObj = dataURLtoBlob(base64Data);
        let localFile = blobToFile([blobObj], fileName);
        resolve(localFile);
      };
      image.onerror = (err) => {
        resolve(file);
      };
      image.src = data;
    };
    reader.onerror = (err) => {
      resolve(file);
    };
    // 传入一个参数对象即可得到基于该参数对象的文本内容
    reader.readAsDataURL(file);
  });
});

import AvatarMale from 'src/assets/images/common/avatar-male@2x.png';
import AvatarFemale from 'src/assets/images/common/avatar-female@2x.png';
import AvatarCommon from 'src/assets/images/common/avatar-common@2x.png';

/**
 * 根据性别获取头像
 * @param gender 性别 0 男性， 1 女性， 2 中性
 */
export const getDefaultAvatar = (util.getDefaultAvatar = function getDefaultAvatar(gender) {
  switch (gender) {
    case 0:
      return AvatarMale;
    case 1:
      return AvatarFemale;
    case 2:
    default:
      return AvatarCommon;
  }
});

// 邮箱脱敏
// export const sensitiveEmail = (util.sensitiveEmail = (email) => {
//   if (!email) return email;
//   let emailAry = email.split('@'),
//     emailTitle = emailAry[0];
//   if (emailTitle) {
//     let emailLen = emailTitle.length,
//       emailLenHalf = Math.floor(emailLen / 2),
//       emailLenStart = Math.floor((emailLen - emailLenHalf) / 2),
//       emailLenEnd = emailLenStart + emailLenHalf,
//       newEmailAry = [],
//       pos = 0;
//     while (pos < emailLen) {
//       if (pos < emailLenStart) {
//         newEmailAry.push(emailTitle[pos]);
//       } else if (pos < emailLenEnd) {
//         newEmailAry.push('*');
//       } else {
//         newEmailAry.push(emailTitle[pos]);
//       }
//       pos++;
//     }
//     emailAry[0] = newEmailAry.join('');
//     return emailAry.join('@');
//   }
//   return email;
// });
// 手机号验证
export const mobileToValidate = (util.mobileToValidate = (mobile) => {
  return /^1[0-9]{10}$/gim.test(mobile);
});

// 加密处理
export const enCodeWithAES = (util.enCodeWithAES = (word) => {
  let cryptoJSInfo = getCryptoJSEnCodeInfo();
  return CryptoJS.AES.encrypt(word, cryptoJSInfo.CryptoJSKey, cryptoJSInfo.CryptoJSEnCodeMode).toString();
});

// 解密处理
export const deCodeWithAES = (util.deCodeWithAES = (ciphertext) => {
  let cryptoJSInfo = getCryptoJSEnCodeInfo();
  let bytes = CryptoJS.AES.decrypt(ciphertext, cryptoJSInfo.CryptoJSKey, cryptoJSInfo.CryptoJSEnCodeMode);
  return bytes.toString(CryptoJS.enc.Utf8);
});

export const rsaEncrypt = (util.rsaEncrypt = (login, publicKey) => {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  return encrypt.encrypt(login);
});

// 千分位
export const formatByThousands = (util.formatByThousands = (num) => {
  num += '';
  if (!num.includes('.')) num += '.';
  return num
    .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
      return $1 + ',';
    })
    .replace(/\.$/, '');
});

/**
 * 前端加密显示字符
 * 显示前4位 其他*号显示 目前银企直联私钥显示处使用 默认
 * 支持传入明文数
 * 添加前后限制位数
 */
export function encryptionValue(value, startNum = 4, endNum = 4) {
  const rule = '[\\s\\S]';
  const reg = new RegExp(`(${rule}{${startNum}})(${rule}+)(${rule}{${endNum}})$`, 'g');
  return `${value || ''}`.replace(reg, (target, $1, $2, $3) => {
    return $1 + $2.replace(/\S/g, '*') + $3;
  });
}

/**
 * @name convertFloatsToString
 * @desc 将数据中的number类型进行string处理。ios可能会出现精度丢失 issue-162166
 * @param obj
 */
export function convertFloatsToString(obj) {
  for (let key in obj) {
    if (typeof obj[key] === 'number' && obj[key] % 1 !== 0) {
      // 是小数，转换为字符串
      obj[key] = obj[key].toString();
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      // 如果是嵌套的对象，递归处理
      convertFloatsToString(obj[key]);
    }
  }
}

export default util;
